<template lang="pug">
  .settings
    van-nav-bar(:title="$t('settings.title')")
      van-icon(name="menu" slot="left" @click="openSidenav")

    .main
      .van-cell-group__title {{ $t("settings.title") }}

      van-cell-group
        //- Selector de idioma
        van-cell(
          :title="$t('settings.language')"
          :value="lang"
          is-link
          @click="showLanguages()")

      .van-cell-group__title {{ $t("settings.general") }}

      van-cell-group
        //- Versión de la aplicación
        van-cell(
          :title="$t('settings.appVersion')"
          :value="version")

        //- Regulaciones energéticas
        van-cell(
          :title="$t('settings.regulations')"
          is-link
          @click="showDocs('regulations')")

        //- Términos de uso
        van-cell(
          v-if="certTerms"
          :title="$t('auth.terms')"
          is-link
          @click="openLinkMixin(certTerms)")

        //- Licencia de usuario final
        van-cell(
          v-if="certLicense"
          :title="$t('auth.license')"
          is-link
          @click="openLinkMixin(certLicense)")

        //- Política de Privacidad
        van-cell(
          v-if="certPrivacy"
          :title="$t('auth.privacy')"
          is-link
          @click="openLinkMixin(certPrivacy)")


    //- Popup Selector de idioma
    SetLanguage(
      v-if="openLanguages"
      @close="hideLanguages")

    //- Popup Mostrar documentación
    RenderDocs(
      v-if="openDocs"
      base="docs/"
      :docData="docData"
      @close="hideDocs")
</template>

<script>
import i18n from '@/locales/i18n';
import { mapGetters, mapActions } from 'vuex';
import { DOCS, LANGUAGE } from '@/app.config';
import OpenLinkMixin from '@/mixins/OpenLink.mixin';
import SetLanguage from '@/components/Settings/SetLanguage.vue';
import RenderDocs from '@/components/RenderDocs.vue';
import { version } from '../../../../package.json';

export default {
  components: { SetLanguage, RenderDocs },
  mixins: [OpenLinkMixin],
  data() {
    return {
      openDocs: false,
      openLanguages: false,
      docData: null,
    };
  },
  computed: {
    ...mapGetters({
      language: 'globalModule/getLanguage',
    }),

    lang() {
      return LANGUAGE.LANGUAGES[this.language];
    },
    version() {
      return version;
    },
    certPrivacy() {
      return DOCS.PRIVACY[i18n.locale.toUpperCase()] || DOCS.PRIVACY.EN;
    },

    certLicense() {
      return DOCS.LEGAL[i18n.locale.toUpperCase()] || DOCS.LEGAL.EN;
    },

    certTerms() {
      return DOCS.TERMS[i18n.locale.toUpperCase()] || DOCS.TERMS.EN;
    },
  },
  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    /**
     * Muestra el popup con el selector del idioma
     */
    showLanguages() {
      this.openLanguages = true;
    },

    /**
     * Oculta el popup con el selector del idioma
     */
    hideLanguages() {
      this.openLanguages = false;
    },

    /**
     * Muestra el popup con la documentación
     */
    showDocs(file) {
      this.docData = {
        title: i18n.t(`settings.${file}`),
        video: null,
        path: `${i18n.locale.toLowerCase()}/${file}.md`,
      };
      this.openDocs = true;
    },

    /**
     * Oculta el popup con la documentación
     */
    hideDocs() {
      this.docData = null;
      this.openDocs = false;
    },
  },
};
</script>
